<template>
  <div v-if="wantsDelivery">
      <slot><p><strong>{{$t('vue.checkout.newCustomer.deliveryAddressNewCustomer.addressForDelivery')}}</strong></p></slot>

    <span class="condensed">
      {{ consumer.first_name }} {{ consumer.last_name }}
    </span> <br>

    <div v-if="editmode">
      <div class="row justify-content-center align-items-top">
        <div class="col-12">
            <p class="condensed">
                {{$t('vue.checkout.newCustomer.deliveryAddressNewCustomer.adjustDeliveryAddress')}}
            </p>

            <div class="form-row">
              <div class="col-12 form-group">
                <label for="fields_street">{{$t('general.addressAndNumber')}}</label>
                <input required type="text"
                       id="fields_street"
                       class="form-control"
                       name="address[street]"
                       :class="getValidationClass(fields.street.valid)"
                       :placeholder="$t('general.addressNumber')"
                       @change="validateStreet"
                       v-model="fields.street.value">
                <div class="invalid-feedback">
                  {{ fields.street.error }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12 form-group">
                <label for="fields_postal_code">{{$t('general.postcode')}}</label>
                <input required
                       type="number"
                       pattern="[0-9]*"
                       name="address[postal_code]"
                       id="fields_postal_code"
                       maxlength="4"
                       class="form-control"
                       :class="getValidationClass(fields.postalCode.valid)"
                       :placeholder="$t('general.postcodeShort')"
                       @change="validatePostalCode"
                       v-model="fields.postalCode.value">
                <div class="invalid-feedback">
                  {{ fields.postalCode.error }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12 form-group">
                <label for="fields_city">{{ $t('general.place')}}</label>
                <input required type="text" name="address[city]" id="fields_city"
                       class="form-control"
                       :class="getValidationClass(fields.city.valid)"
                       :placeholder="$t('general.placeCity')"
                       @change="validateCity"
                       v-model="fields.city.value">
                <div class="invalid-feedback">
                  {{ fields.city.error }}
                </div>
              </div>
            </div>
        </div>
      </div>

      <button type="button" class="btn btn-link" @click="editmode = !editmode">{{ $t('general.abort') }}</button>
      <button type="button" class="btn btn-primary" @click="saveDeliveryAddress">{{ $t('consumer.dashboard.save') }}</button>
    </div>

    <div v-else>
      <p class="condensed pb-2">
        <span class="condensed" v-if="addressHasCompany">{{ address.company }}<br></span>
        {{ deliveryAddress.street }} {{deliveryAddress.house_number}}<br>
        {{ deliveryAddress.postal_code }} {{ deliveryAddress.city }}
      </p>

      <a class="btn btn-link p-0" @click="editmode = !editmode">
        <i class="far fa-pencil-alt"></i>
        {{ $t('vue.checkout.newCustomer.deliveryAddressNewCustomer.updateAddress')}}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeliveryAddressNewCustomer",
  props: {
    subscription: {
      type: Object,
      required: true
    },
    isCheckoutOverview: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data(){
    return {
      editmode: false,
      fields: {
        country: {
          value: ""
        },
        street: {
          value: "",
          valid: 0,
          error: "",
          success: ""
        },
        postalCode: {
          value: "",
          valid: 0,
          error: "",
          success: ""
        },
        city: {
          value: "",
          valid: 0,
          error: "",
          success: ""
        },
      }
    }
  },

  methods: {
    saveDeliveryAddress() {
      axios.patch('/api/checkout/' + this.subscription.id + '/update-addresses', {
        address_data: {
          street: this.fields.street.value,
          postal_code: this.fields.postalCode.value,
          city: this.fields.city.value,
          country: this.fields.country.value,
          company: ""
        },
        addressType: 'delivery',
        identifier: this.subscription.identifier
      }).then(r => {
        console.log(r, r.status)
        if(r.status === 200) {
          location.reload()
        }

      }).catch(e => {
        console.log(e)
      })
    },
    getValidationClass (valid) {
      // valid could be -1,0,1
      let className = '';
      switch (valid) {
        case -1:
          className = 'is-invalid';
          break;
        case 1:
          className = 'is-valid';
          break;
        default:
          className = '';
          break;
      }
      return className;
    },
    validateStreet () {
      let street = this.fields.street.value;
      if (street.length > 0) {
        let re = /^\d+$/;
        let invalid = re.test (street); // Contains numbers only
        this.fields.street.valid = invalid ? -1 : 1;
      } else {
        this.fields.street.valid = 0;
      }
    },
    validatePostalCode () {
      let plz = this.fields.postalCode.value;
      if (plz.length === 0) {
        this.fields.postalCode.valid = 0;
      } else if (plz.length > 4) {
        this.fields.postalCode.valid = -1;
      } else {
        let re = /\b\d{4,5}(?:-\d{4})?\b/;
        let valid = re.test (plz);
        this.fields.postalCode.valid = valid ? 1 : -1;
      }
    },
    validateCity () {
      let city = this.fields.city.value;
      if (city.length > 0) {
        let re = /^[A-Za-z\u00C0-\u017F]+$/;
        let valid = re.test (city);
        this.fields.city.valid = valid ? 1 : -1;
      } else {
        this.fields.city.valid = 0;
      }
    },
  },

  computed: {
    addressHasCompany () {
      return this.address.company !== null
    },
    consumer () {
      if (this.subscription.consumer !== null) {
        return this.subscription.consumer
      }

      if (typeof this.subscription.details.consumer != undefined) {
        return this.subscription.details.consumer
      }

      throw Error ("No customer found!")
    },
    address () {
      if (this.subscription.delivery_address !== null) {
        return this.subscription.delivery_address
      }

      if (typeof this.subscription.details.address != undefined) {
        return this.subscription.details.address
      }

      throw Error ("No address found!")
    },
    deliveryAddress () {
      if (this.subscription.delivery_address !== null) {
        return this.subscription.delivery_address;
      } else {
        if (typeof this.subscription.details.deliveryAddress !== null) {
          return this.subscription.details.deliveryAddress;
        } else {
          return this.subscription.details.address;
        }
      }
    },
    wantsDelivery () {
      if (this.isCheckoutOverview) {
        if (this.subscription.details !== null) {
          return this.subscription.details.deliveryMethod === 'delivery';
        }
        return true;
      }
      return true;
    }
  },

  created () {
    const address = this.deliveryAddress

    this.fields.street.value = address.street
    this.fields.postalCode.value = address.postal_code
    this.fields.city.value = address.city
    this.fields.country.value = address.country
  }
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
